import React from 'react';

// import { Newsletter } from '../Newsletter/Newsletter';
import { FooterLinks } from '../FooterLinks/FooterLinks';
import { Disclaimer } from '../Disclaimer/Disclaimer';

// import './Footer.scss';

interface FooterProps {
  theme: 'dark' | 'light';
  newsletter?: boolean;
  className?: string;
  apiEndpoint?: string;
  listID?: number;
}

export function Footer({
  theme,
  newsletter,
  apiEndpoint,
  listID,
  ...rest
}: FooterProps) {
  let classes = 'betterMood__footer';
  classes += ` ${theme === 'dark' ? 'dark' : 'light'}`;

  return (
    <footer className={classes}>
      <div className="betterMood__footer-container">
        {/* { newsletter ? <Newsletter dark={dark || false} white={white || false} apiEndpoint={apiEndpoint} listID={listID} /> : '' } */}
        <FooterLinks theme={theme === 'dark' ? 'dark' : 'light'} />
        <Disclaimer theme={theme} />
      </div>
    </footer>
  );
}
